import { defineComponent as _defineComponent } from 'vue'
import navItems from '@sh/components/Layout/Sidebar/navItems';
import SidebarCard from '@sh/components/Layout/Sidebar/SidebarV2/SidebarCard.ts.vue';
import SidebarDropdown from '@sh/components/Layout/Sidebar/SidebarV2/SidebarDropdown.ts.vue';
import SidebarItem from '@sh/components/Layout/Sidebar/SidebarV2/SidebarItem.ts.vue';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { canAccess, unleashFeatures } from '@sh/helpers';
import session from '@sh/services/session';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarV2.ts',
  setup(__props) {

const collapsed = ref(false);
const noPermissionItems = ref<string[]>([]);
const isUnleashResponse = ref(false);
const toggledSidebarFromResize = ref(false);
const openedNavMenu = ref<string>('');

const minWidthForCollapse = 992;

if (localStorage.getItem('sidebar-collapsed') === 'true' && window.innerWidth >= minWidthForCollapse)
  collapsed.value = true;

const filteredNavItems = computed(() => {
  return (
    (session.isSearchFeed &&
      navItems.compliance.filter(
        (item) => !item.isUnleashProtected || (isUnleashResponse.value && !noPermissionItems.value.includes(item.url))
      )) ||
    navItems.native
      .map((item) => ({ ...item, opened: false }))
      .filter(
        (item) => !item.isUnleashProtected || (isUnleashResponse.value && !noPermissionItems.value.includes(item.id))
      )
  );
});

unleashFeatures.forEach(async (item, index) => {
  if (!(await canAccess(item))) {
    if (item.charAt(0) !== '/') {
      item = `/${item}`;
    }
    noPermissionItems.value.push(item);
  }
  isUnleashResponse.value = index === unleashFeatures.length - 1;
});

function toggleSidebar() {
  if (window.innerWidth < minWidthForCollapse && !collapsed.value) {
    collapsed.value = true;
    toggledSidebarFromResize.value = true;
  }
  if (toggledSidebarFromResize.value && window.innerWidth >= minWidthForCollapse) {
    collapsed.value = false;
  }
}

toggleSidebar();
window.addEventListener('resize', () => toggleSidebar());

function onSidebarCollapse() {
  collapsed.value = !collapsed.value;
  toggledSidebarFromResize.value = false;
  localStorage.setItem('sidebar-collapsed', collapsed.value.toString());
}

function updateCollapsedDropdowns(id: string, value: boolean) {
  openedNavMenu.value = value ? '' : id;
}

return { __sfc: true,collapsed, noPermissionItems, isUnleashResponse, toggledSidebarFromResize, openedNavMenu, minWidthForCollapse, filteredNavItems, toggleSidebar, onSidebarCollapse, updateCollapsedDropdowns, SidebarCard, SidebarDropdown, SidebarItem, OptimizerIconV2 }
}

})